var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconGoogleg = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 65.264 66.782"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.66 33.391c0-2.169.359-4.249 1.001-6.198L3.424 18.599A33.416 33.416 0 000 33.391a33.41 33.41 0 003.419 14.782l11.232-8.611a19.78 19.78 0 01-.991-6.171z",
  fill: "#fbbc05"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.391 13.66c4.705 0 8.955 1.67 12.294 4.402l9.714-9.714C49.479 3.187 41.89 0 33.391 0A33.288 33.288 0 003.424 18.599l11.237 8.593a19.682 19.682 0 0118.73-13.532z",
  fill: "#ea4335"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.661 39.589L3.424 48.182a33.286 33.286 0 0029.967 18.599c8.144 0 15.92-2.896 21.756-8.322L44.48 50.201c-3.01 1.899-6.8 2.92-11.089 2.92a19.68 19.68 0 01-18.73-13.532z",
  fill: "#34a853"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M65.264 33.391c0-1.973-.304-4.098-.759-6.071H33.391v12.901H51.3c-.896 4.399-3.333 7.781-6.82 9.981l10.667 8.258c6.129-5.698 10.117-14.185 10.117-25.069z",
  fill: "#4285f4"
})));
export default SvgIconGoogleg;